import React, { useContext } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { ContentfulDocument } from 'types/contentful/graphQlApi'
import Translations from '@helpers/translations'
import { Button } from '@components/ui/Button'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel
} from '@components/ui/Accordion'
import ProductContext from '../context'
import styles from './styles.module.scss'
import SizeAndFitInstructions from './FitInstructions'
import { ProductWithVariants } from 'types/product'
import { fitInstructionsExists } from '@helpers/products/fitInstructions'

type ProductInfoProps = {
  toggleOOSModal: () => void
  product: ProductWithVariants
  text?: string
  isAbTestMadeToOrderOxfords: boolean
}

function ProductInfo({
  text,
  product,
  toggleOOSModal,
  isAbTestMadeToOrderOxfords
}: ProductInfoProps) {
  const { careCopy } = useContext(ProductContext)
  const { product_type: productType } = product
  const isReturnableProduct = text && productType !== 'Trunks'
  const hasFitInstructions = text && fitInstructionsExists(productType)

  const returnsAndExchanges = Translations.localise(
    'product.returns-and-exchanges-instructions.lines'
  ).split('|')

  const listOfReturnsAndExchanges = isAbTestMadeToOrderOxfords
    ? returnsAndExchanges.slice(1)
    : returnsAndExchanges

  return (
    <Accordion
      id="ProductInfoAccordion"
      classes={styles.accordion}
      defaultOpen={[0]}
    >
      {text ? (
        <AccordionItem>
          <AccordionButton>
            {Translations.localise('product.accordion.product-details')}
          </AccordionButton>
          <AccordionPanel>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </AccordionPanel>
        </AccordionItem>
      ) : null}

      {hasFitInstructions ? (
        <AccordionItem>
          <AccordionButton>
            {Translations.localise('product.accordion.size-and-fit')}
          </AccordionButton>
          <AccordionPanel>
            <SizeAndFitInstructions product={product} />
          </AccordionPanel>
        </AccordionItem>
      ) : null}

      {careCopy ? (
        <AccordionItem>
          <AccordionButton>
            {Translations.localise('product.accordion.care')}
          </AccordionButton>
          <AccordionPanel>
            {documentToReactComponents(
              careCopy as unknown as ContentfulDocument
            )}
          </AccordionPanel>
        </AccordionItem>
      ) : null}

      {isReturnableProduct ? (
        <AccordionItem>
          <AccordionButton>
            {Translations.localise('product.accordion.returns-and-exchanges')}
          </AccordionButton>
          <AccordionPanel>
            <ul>
              {listOfReturnsAndExchanges.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
          </AccordionPanel>
        </AccordionItem>
      ) : null}

      <AccordionItem>
        <AccordionButton>
          {Translations.localise('product.accordion.size-not-in-stock')}
        </AccordionButton>
        <AccordionPanel>
          <p>{Translations.localise('product.oos.title')}</p>
          <br />
          <Button
            variant="secondary"
            fullWidth="always"
            onClick={toggleOOSModal}
          >
            {Translations.localise('product.oos.button')}
          </Button>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default ProductInfo
